import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccionesComponent } from './acciones.component';

import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxWindowModule } from 'jqwidgets-ng/jqxwindow';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';

@NgModule({
  declarations: [AccionesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    jqxLoaderModule,
    jqxWindowModule,
    jqxGridModule,
    jqxButtonModule,
    jqxInputModule,
    jqxDropDownListModule,
  ],
  exports: [AccionesComponent],
})
export class AccionesModule {}
